const config = {
    path: '/webviewer/lib',
    licenseKey: window.RG_CONFIG.APRYSE_LICENSE,
    disabledElements: [
        'contextMenuPopup',
        'copyTextButton',
        'leftPanelButton',
        'menuButton',
        'panToolButton',
        'selectToolButton',
        'toolbarGroup-View',
        'toggleCompareModeButton',
        'toggleNotesButton',
    ],
    disableLogs: !window.RG_CONFIG.DEBUG,
};
export default config;
